import React, { useEffect, useState, useContext } from 'react';
import { Line } from 'react-chartjs-2';
import axiosConn from '../../axiosConn';
import { AuthContext } from '../../context/AuthContext';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
);

const CheckInTrendsChart = ({ businessId, region, city }) => {
  const { player } = useContext(AuthContext);
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchTrends = async () => {
      try {
        const { data } = await axiosConn.get('checkins/trends', {
          params: { businessId, region, city },
          headers: { Authorization: `Bearer ${player?.token}` },
        });
        setChartData({
          labels: data.labels,
          datasets: [
            {
              label: 'Check-Ins per Day',
              data: data.data,
              fill: false,
              borderColor: '#00bfff',
              backgroundColor: '#00bfff',
              tension: 0.3,
              pointRadius: 3,
              pointHoverRadius: 6,
            },
          ],
        });
      } catch (err) {
        console.error('Failed to load trends data:', err);
      }
    };

    fetchTrends();
  }, [businessId, region, city, player?.token]);

  if (!chartData) return <p>Loading trend chart...</p>;

  return (
    <div
      className="p-3 bg-white rounded shadow-sm"
      style={{ height: 340, width: '100%' }}
    >
      <h5 className="mb-3">📈 Check-In Trends</h5>
      <Line
        data={chartData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: true, position: 'bottom' },
          },
          scales: {
            x: { title: { display: true, text: 'Date' } },
            y: {
              beginAtZero: true,
              title: { display: true, text: 'Check-Ins' },
              precision: 0,
              ticks: { stepSize: 1 },
            },
          },
        }}
      />
    </div>
  );
};

export default CheckInTrendsChart;
